import script from "./detailStudent.vue?vue&type=script&setup=true&lang=js"
export * from "./detailStudent.vue?vue&type=script&setup=true&lang=js"

import "./detailStudent.vue?vue&type=style&index=0&id=fe39cee0&scoped=true&lang=scss"

import exportComponent from "E:\\project\\lms-frontend-admin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fe39cee0"]])

export default __exports__